module.exports = __webpack_public_path__ + "static/media/illustration.992182f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration.svg
// module id = 27
// module chunks = 0